import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { confirmPaymentThanhToan, createOrderFromStaff, getAllProducts } from '../api';
import { setAllProducts } from '../context/actions/productAction';
import { addProductToThanhToan, removeAllProductsFromThanhToan, removeProductFromThanhToan, setAllProductsThanhToan, updateProductThanhToan } from '../context/actions/thanhToanActions';
import { AiOutlineCheck } from 'react-icons/ai';
import { useState } from 'react';
import NotFoundPage from '../components/NotFoundPage';
import { alertDanger, alertNULL, alertSuccess } from '../context/actions/alertActions';
import { DBOrders } from '../components';

const ThanhToanHoaDon = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const products = useSelector(state => state.products) || [];
    const productsThanhToan = useSelector(state => state.thanhtoan.products);
    const [isDashboard, setIsDashboard] = useState(false)
    const requestQueue = [];
    let isProcessing = false;
    const [loading, setLoading] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isNewTempProduct, setIsNewTempProduct] = useState(false);
    const [selectedValue, setSelectedValue] = useState(0);
    const [totalCurrentOrder, setTotalCurrentOrder] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState([])
    const [openAddingPriceProduct, setOpenAddingPriceProduct] = useState(false)


    const handleDisplayProducts = (category) => {
        setIsNewTempProduct(false)
        setSelectedCategory(category);
    }

    const processQueue = async () => {
        // Ensure only one request is being processed at a time
        if (isProcessing) return;
        isProcessing = true;
        // Process the requests in the queue
        while (requestQueue.length > 0) {
            const { product, index } = requestQueue.shift();
            try {
                // Make the API call here
                dispatch(removeProductFromThanhToan(index));
                dispatch(alertSuccess('Xác nhận đơn hàng thành công'));
                await confirmPaymentThanhToan(product, user);
            } catch (err) {
                console.error('Error:', err.message);
            }
        }
        isProcessing = false;
    };

    useEffect(() => {
        const localStorageThanhToan = JSON.parse(localStorage.getItem('productsThanhToan'));
        if (localStorageThanhToan && (localStorageThanhToan.length > productsThanhToan.length) && (productsThanhToan.length === 0)) {
            dispatch(setAllProductsThanhToan(localStorageThanhToan));
        } else {
            localStorage.setItem('productsThanhToan', JSON.stringify(productsThanhToan));
        }
    }, [productsThanhToan]);

    useEffect(() => {
        const fetchDataProducts = async () => {
            try {
                const productsData = await getAllProducts();
                dispatch(setAllProducts(productsData));
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };
        fetchDataProducts();
    }, [dispatch]);

    const groupedProducts = products.reduce((acc, product) => {
        const category = product.product_category;

        if (!acc[category]) {
            acc[category] = [];
        }

        acc[category].push(product);

        acc[category].sort((a, b) => a.product_name.localeCompare(b.product_name));
        return acc;
    }, {});

    const handleAddToCart = (product) => {
        dispatch(addProductToThanhToan(product));
    };

    const handleRemoveCart = (index) => {
        if (index === 0 && productsThanhToan.length === 1) {
            localStorage.removeItem('productsThanhToan');
        }
        dispatch(removeProductFromThanhToan(index))
    }

    const handleConfirmPayment = async (product, index) => {
        try {
            if (productsThanhToan.length === 1) {
                localStorage.removeItem('productsThanhToan');
            }
            requestQueue.push({ product, index });
            await processQueue();
            setTimeout(() => {
                dispatch(alertNULL());
            }, 3000);
        } catch (err) {
            console.error('Error:', err.message);
        }
    };

    const handlePaymentAllCurrentItems = async () => {
        setLoading(true)
        const orderData = {
            orders: productsThanhToan,
            user: user,
            paymentMethod: 'Tiền mặt',
        }
        if (orderData.orders.length === 0) {
            dispatch(alertDanger('Lỗi! Đơn hàng trống!'));
            setTimeout(() => {
                dispatch(alertNULL());
            }, 3000);
            setLoading(false)
            return
        }
        try {
            const result = await createOrderFromStaff(orderData)
            if (result) {
                localStorage.removeItem('productsThanhToan');
                dispatch(removeAllProductsFromThanhToan())
                dispatch(alertSuccess('Xác nhận đơn hàng thành công'));
                setTimeout(() => {
                    dispatch(alertNULL());
                }, 3000);
            } else {
                // Handle error
                console.error("Error creating order.");
            }
        } catch (err) {
            console.log('err: ', err.message)
        }
        setLoading(false)
    }

    const handleSelectionChange = (event) => {
        setSelectedValue(event.target.value)
    }

    const handleAddSelectionChange = () => {
        const newProductPrice = parseFloat(parseInt(selectedValue) + parseInt(selectedProduct.product_price)); // Convert to a valid number if needed

        // Create a new object with the updated product_price
        const updatedSelectedProduct = {
            ...selectedProduct,
            product_price: newProductPrice,
        };

        dispatch(updateProductThanhToan(updatedSelectedProduct))
        setOpenAddingPriceProduct(false)
    };


    const handleActionsOnProductThanhToan = (product) => {
        setSelectedProduct(product)
        setOpenAddingPriceProduct(true)
    }


    // Generate options from 1000 to 20000 with increments of 1000
    const options = [];
    for (let i = 1000; i <= 20000; i += 1000) {
        options.push(<option key={i} value={i}>{i}</option>);
    }

    useEffect(() => {
        if (!Array.isArray(productsThanhToan)) {
            console.error('productsThanhToan is not an array.');
            return;
        }

        let totalMoney = 0;
        productsThanhToan.forEach(order => {
            if (order.product_price) {
                totalMoney += parseInt(order.product_price, 10);
            }
        });

        setTotalCurrentOrder(totalMoney);
    }, [productsThanhToan]);

    return (
        <> <div className='flex pt-2 pl-2 gap-4'>
            <div className='bg-green-700 text-white cursor-pointer p-2'
                onClick={() => setIsDashboard(true)}
            >khu Đơn hàng</div>
            <div className='bg-red-700 text-white cursor-pointer p-2'
                onClick={() => setIsDashboard(false)}
            >Khu vực thanh toán</div>
        </div>
            {(user && (user.role === "Staff" || user.role === "admin" || user.role.toLowerCase() === "moderator")) ? (
                <> {isDashboard ? (<DBOrders />) : (
                    <div className='flex flex-col md:flex-row justify-between p-4'>
                        <div className="flex w-full">
                            <div className='flex gap-2 flex-col'>
                                {Object.entries(groupedProducts).map(([category, products]) => (
                                    <h2
                                        className={`w-[100px] md:w-[200px] text-sm ${selectedCategory === category ? 'bg-blue-700 text-white' : 'bg-white'} cursor-pointer md:text-lg font-bold mb-2 py-2 px-4 rounded-md  border-2 border-slate-900`}
                                        onClick={() => handleDisplayProducts(category)}
                                    >
                                        {category}
                                    </h2>
                                ))}
                                {/* <div className='w-auto cursor-pointer text-lg font-bold mb-2 py-2 px-4 rounded-md bg-amber-400 border-2 border-slate-900'
                                    onClick={() => setIsNewTempProduct(true)}
                                >
                                    Khác
                                </div> */}
                            </div>
                            {isNewTempProduct ? (<>
                                {/* <div className='flex items-center gap-2 mt-4 justify-center'>
                                    <select className="p-4 border rounded-md" onChange={handleSelectionChange}>
                                        <option value="">Chọn số tiền : </option>
                                        {options}
                                    </select>
                                    <div className='cursor-pointer p-4 flex justify-center items-center bg-green-500'
                                        onClick={() => handleAddSelectionChange()}
                                    >Thêm</div>
                                </div> */}
                            </>) : (
                                Object.entries(groupedProducts).map(([category, products]) => (
                                    <div key={category}>
                                        <div className={`flex flex-wrap`}>
                                            {selectedCategory === category && products.map((product, index) => (
                                                <div className='flex w-1/2 flex-col'>
                                                    <div className='flex justify-center items-center relative top-[30px]'>
                                                        {/* <img src={product.imageURL} className='w-20 h-20' alt="" loading="lazy"/> */}
                                                    </div>
                                                    <button
                                                        key={index}
                                                        className="z-[20] m-2 md:w-auto text-sm md:text-lg px-4 py-2 bg-blue-500 text-white rounded"
                                                        onClick={() => handleAddToCart(product)}
                                                    >
                                                        {product.product_name} <br /> <span className='text-yellow-300'>{product.product_price}</span>
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))
                            )}

                        </div>
                        <div className='md:w-2/4 flex flex-col justify-start border-l-2 border-l-emerald-950'>
                            <div className='w-full flex flex-col items-center justify-center relative'>
                                <h1 className='w-full text-center p-4 font-bold text-lg border-b-2 border-teal-400'>Đơn hàng hiện tại </h1>
                                <div className='p-2 my-2 rounded-md bg-yellow-100 border-2 border-black'>tổng : {totalCurrentOrder.toLocaleString()} VND</div>
                            </div>
                            <div className='flex justify-center items-center gap-2'>
                                <div className='cursor-pointer flex justify-center items-center select-none text-sm'
                                ><span className='p-2 rounded-md bg-yellow-300 hidden'>thanh toán 1 phần</span></div>
                                <button
                                    disabled={loading}
                                    className={`cursor-pointer flex justify-center items-center select-none text-sm`}
                                    onClick={() => handlePaymentAllCurrentItems()}
                                >
                                    <span className={`p-2 rounded-md ${loading ? `bg-red-200` : `bg-emerald-500`} text-yellow-100`}>{loading ? `Đang xử lý` : `Thanh toán toàn bộ`}</span>
                                </button>
                            </div>
                            <div className="flex flex-col w-full pl-2">
                                {/* // productThanhToan  */}
                                {Object.entries(productsThanhToan).map(([productId, product], index) => (
                                    <>
                                        <div className='flex justify-between items-center py-2 '>
                                            <div className='text-sm px-2 bg-slate-300 mr-2'>{product.orderTime}</div>
                                            <div className='flex justify-center cursor-pointer align-center px-4 py-2 rounded-md bg-green-400'
                                                onClick={() => { handleConfirmPayment(product, index) }}
                                            ><AiOutlineCheck /></div>
                                            <div key={index} className="m-2 py-2 text-center cursor-pointer bg-blue-500 w-full text-sm text-white rounded"
                                                onClick={() => handleActionsOnProductThanhToan(product)}
                                            >
                                                {product.product_name}
                                            </div>
                                            <div key={`price_${index}`} className="m-2 py-2 text-sm bg-yellow-400 text-black rounded">
                                                {parseInt(product.product_price).toLocaleString()}VND
                                            </div>
                                            <div className='flex select-none justify-center cursor-pointer align-center px-4 py-2 rounded-md bg-red-400'
                                                onClick={() => { handleRemoveCart(index) }}
                                            >X</div>
                                        </div>
                                    </>
                                ))}

                            </div>
                        </div>
                    </div >
                )}

                </>
            ) : (
                <NotFoundPage /> // Use the NotFoundPage component here
            )}
            {openAddingPriceProduct && (<>
                <div className='absolute top-0 w-full h-full bg-black opacity-40 z-[19]'>
                </div>
                <div className='absolute top-0 w-full h-full flex justify-center items-center z-[20]'>
                    <div className='bg-white flex justify-center items-center w-[400px] h-[200px]'>
                        <div className='flex items-center gap-2 mt-4 justify-center'>
                            <select className="p-4 border rounded-md" onChange={handleSelectionChange}>
                                <option value="">Chọn số tiền : </option>
                                {options}
                            </select>
                            <div className='cursor-pointer p-4 flex justify-center items-center bg-green-500'
                                onClick={() => handleAddSelectionChange()}
                            >Thêm</div>
                        </div>
                    </div>
                </div>
            </>)}

        </>
    );
};

export default ThanhToanHoaDon;